
import emitter from "../event/eventBus";
import { defineComponent, reactive, toRefs, watch } from "vue";
interface LangType {
   label:string,
   value:string
}
const enArr = [
  {
    label: "en",
    value: "en",
  },
  {
    label: "zh",
    value: "zh",
  },
];
const zhArr = [
  {
    label: "英文",
    value: "en",
  },
  {
    label: "中文",
    value: "zh",
  },
];

const changeLangArr = (lang:string):LangType [] => (lang === "en" ? enArr : zhArr);
export default defineComponent({
  setup() {
    const state = reactive({
      langArr:enArr,
      currentLang: "en",
    });
    state.langArr = changeLangArr(state.currentLang);
    watch(
      () => state.currentLang,
      (val: string) => {
        state.langArr = changeLangArr(state.currentLang);
      }
    );
    const changeCurrentLang = (val:string) => {
        state.currentLang = val;
        emitter.$emit("on-change-lang",() => state.currentLang);
    }
    return {
      ...toRefs(state),
      changeCurrentLang
    };
  },
});
